import { render, staticRenderFns } from "./FeedbackListEntry.vue?vue&type=template&id=05e71156&"
import script from "./FeedbackListEntry.vue?vue&type=script&lang=js&"
export * from "./FeedbackListEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/plenty/Desktop/work/feedback-plugin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e71156')) {
      api.createRecord('05e71156', component.options)
    } else {
      api.reload('05e71156', component.options)
    }
    module.hot.accept("./FeedbackListEntry.vue?vue&type=template&id=05e71156&", function () {
      api.rerender('05e71156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/singleitem/FeedbackListEntry.vue"
export default component.exports